import { useCallback, useEffect, useState } from 'react'

import { ConfiguracoesVideochamadaModel, StoredDeviceKey } from '../model-videochamada'
import { useStoredDevice } from './useVideochamadaStorage'

interface UseMediaDevicesConfigurationProps {
  mediaDevices: ConfiguracoesVideochamadaModel
  audioEnabled: boolean
  videoEnabled: boolean
}

export function useMediaDevicesConfiguration({
  mediaDevices,
  audioEnabled,
  videoEnabled,
}: UseMediaDevicesConfigurationProps) {
  const [mediaDevicesConfiguration, setMediaDevicesConfiguration] = useState<ConfiguracoesVideochamadaModel>()
  const [storedAudioDevice, setStoredAudioDevice] = useStoredDevice(StoredDeviceKey.AUDIO_INPUT)
  const [storedVideoDevice, setStoredVideoDevice] = useStoredDevice(StoredDeviceKey.VIDEO_INPUT)
  const [storedAudioOutputDevice, setStoredAudioOutputDevice] = useStoredDevice(StoredDeviceKey.AUDIO_OUTPUT)

  const getMediaDevicesConfiguration = useCallback(
    ({ mediaDevices, audioEnabled, videoEnabled }: UseMediaDevicesConfigurationProps) => {
      setMediaDevicesConfiguration({
        audioInput: audioEnabled ? mediaDevices?.audioInput : storedAudioDevice,
        audioOutput: storedAudioOutputDevice ?? mediaDevices?.audioOutput,
        videoInput: videoEnabled ? mediaDevices?.videoInput : storedVideoDevice,
      })
    },
    [storedAudioDevice, storedVideoDevice, storedAudioOutputDevice]
  )

  useEffect(() => {
    if (mediaDevices?.audioInput?.id) setStoredAudioDevice(mediaDevices.audioInput)
    if (mediaDevices?.videoInput?.id) setStoredVideoDevice(mediaDevices.videoInput)

    getMediaDevicesConfiguration({ mediaDevices, audioEnabled, videoEnabled })
  }, [
    mediaDevices,
    audioEnabled,
    videoEnabled,
    setStoredAudioDevice,
    setStoredVideoDevice,
    getMediaDevicesConfiguration,
  ])

  return { mediaDevicesConfiguration, setStoredAudioDevice, setStoredVideoDevice, setStoredAudioOutputDevice }
}
